module.exports = __webpack_public_path__ + "img/maintop.7b023f9.png";